const playerColors = [
  '#FF6B6B',
  '#4ECDC4',
  '#AB47BC',
  '#66BB6A',
  '#F9A825',
  '#AB47BC',
  '#FF6B6B',
];
export const randomColor = () =>
  playerColors[Math.floor(Math.random() * playerColors.length)];
export const updatedLeaderBoard = (players: LeaderboardEntry[]) => {
  return players
    .map((p) => ({ ...p, iconColor: randomColor() }))
    .sort((a, b) => b.totalPoints - a.totalPoints)
    .map((p, i) => ({ ...p, rank: i + 1 }));
};

export const quizAccuracy = (player: LeaderboardEntry, totalQuiz: number) => {
  return Math.round((player.correctCount / totalQuiz) * 100);
};
